import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey30, grey10 } from "@churchofjesuschrist/eden-style-constants";
import { StyledTHead } from "./THead";
import { StyledTBody } from "./TBody";
import { StyledTR } from "./TR"; // The "double" style helps override the "solid" border style on the cell
// border declaration. (See https://www.w3.org/TR/CSS2/tables.html#border-conflict-resolution)

const groupBorder = `1px double ${grey30}`; // The following CSS will automatically include vertical rules (borders) when
// column grouping is present. However, the `&:not([data-row-selection])`
// selectors are so that the <ColGroup data-row-selection /> which is
// automatically included when row selection is present (see `Table` component)
// does not also trigger the vertical rules by itself.

const StyledColGroup = styled.colgroup.withConfig({
  componentId: "sc-11v6gda-0"
})(["&[span]{border-inline-start:", ";border-inline-end:", ";}&:first-of-type{border-inline-start:0;}&:last-of-type{border-inline-end:0;}&:not([data-row-selection]) ~ ", " ", " > *,&:not([data-row-selection]) ~ ", " ", " > *{border-inline-start:1px solid ", ";&:first-child{border-inline-start:0;}}"], groupBorder, groupBorder,
/* sc-selector */
StyledTHead, StyledTR,
/* sc-selector */
StyledTBody, StyledTR, grey10);

const ColGroup = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(StyledColGroup, props, children);

export { StyledColGroup };
export default ColGroup;
ColGroup.propTypes = {
  /** The number of columns to span. */
  span: PropTypes.string,

  /** The column group contents. */
  children: PropTypes.node
};